import PersonaControlStore, {
    LivePersonaCardInitializationState,
} from './schema/PersonaControlStore';
import PersonaControlViewState from './schema/PersonaControlViewState';
import { BrandListLoadState } from './schema/BrandList';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

var initialPersonaControlStore: PersonaControlStore = {
    viewStates: new ObservableMap<string, PersonaControlViewState>(),
    livePersonaCardInitializationStatus: {
        state: LivePersonaCardInitializationState.NotInitialized,
        timestamp: Date.now(),
    },
    isLivePersonaCardInitialized: false,
    isPersonaCardDisabled: false,
    brandList: null,
    brandListLoadState: BrandListLoadState.unloaded,
};
var store = createStore<PersonaControlStore>('personacontrol', initialPersonaControlStore)();

export default store;
